export const checkImage = path =>
	new Promise((resolve, reject) => {
		const img = new Image()
		img.src = path
		img.onload = () => resolve('true')
		img.onerror = () => reject('err')
	})
